/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.metadataItems').service(
    'MetadataItemsSearchViewService',
	function (
	    this: JS5Object,
	    _: JS5Object,
	    $q: JS5Object,
        MetadataEditService: JS5Object,
        MetaPropsResourceFactory: JS5Object,
        PartnerResourceFactory: JS5Object,
    ) {

		this.getMetadataProperties = (type: string, conversionVariablesOnly: boolean) => {
			return MetaPropsResourceFactory.query({ownerFilter: type})
            .$promise.then((metadataItems: JS5Object) => {
                let ownerPromises: JS5Promise[] = [];
                angular.forEach(metadataItems, (metadataItem: JS5Object) => {
                    ownerPromises.push(MetadataEditService.getGroupNamesByIds(metadataItem.groupIds)
                    .then((groupNames: string[]) => {
                        metadataItem.owners = groupNames;
                        metadataItem.ownersString = groupNames.toString();
                        return metadataItem;
                    }));
                });
                return $q.all(ownerPromises).then((metadataItems: JS5Object[]) => {
                    return metadataItems.filter((metadataItem: JS5Object) => {
                        return conversionVariablesOnly === _.includes(metadataItem.owners, 'Media Conversion');
                    });
                });
			});
		};

		this.getPartnerMetadataProperties = (partnerId: string, showMVPD: boolean) => {
			return PartnerResourceFactory.getMetadataProperties({
                id: partnerId, mvpd: showMVPD
			}).$promise;
		};
	});
